export default "__VITE_ASSET__CojBZ0RK__"